import { CaseClient } from "@app/api2/api";
import { caseRunClient, queriesClient } from "@app/api2/Clients";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// import * as api from "../lib/api";
// import type { InsertReferenceProfile } from "@shared/schema";

export function useCases() {
  return useQuery({
    queryKey: ["cases"],
    queryFn: async () => (await queriesClient.getFamilialSearchRuns(null, null, null, false, 100, 1, 'id', 'desc', null)).items.map(c => ({ id: `${c.labId}_${c.caseId}_${c.id.toString()}`, caseId: `${c.caseName} ${c.id.toString()}`, createdDate: c.created })),//api.getCases(),
  });
}

export function useCase(id: string) {
  return useQuery({
    queryKey: ["cases", id],
    queryFn: async () => (await queriesClient.getFamilialSearchRuns(null, null, null, false, 100, 1, 'id', 'desc', null)).items.map(c => ({ id: `${c.labId}_${c.caseId}_${c.id.toString()}`, caseId: `${c.caseName} ${c.id.toString()}`, createdDate: c.created })).find(c => c.id === id),//api.getCases(),
    enabled: !!id,
  });
}

export function useProfiles(caseId: string) {
  return useQuery({
    queryKey: ["profiles", caseId],
    queryFn: async () => (await queriesClient.getFamilialSearchRuns(null, null, null, false, 100, 1, 'id', 'desc', null)).items.map(c => ({ id: `${c.labId}_${c.caseId}_${c.id.toString()}`, caseId: `${c.caseName} ${c.id.toString()}`, createdDate: c.created })).find(c => c.id === caseId),//api.getProfilesByCase(caseId),
    enabled: !!caseId,
  });
}

export function useKinshipRecords(caseId: string) {
  return useQuery({
    queryKey: ["kinship", caseId],
    queryFn: async () => {
      if (!caseId) return [];
      // return [];
      const labId = caseId.split('_')[0];
      const caseIdPart = caseId.split('_')[1];
      const caseRunId = caseId.split('_')[2];
      console.log("Fetching kinship records for caseId:", caseId);
      const results = await caseRunClient.getFamilialSearchResults(parseInt(labId), parseInt(caseIdPart), parseInt(caseRunId), 100, 1, 'resultId', 'desc');
      console.log("Fetched kinship records for caseId:", results.items);
      try {
        const resultsData = results.items.map(c => ({
          id: c.resultId,
          caseId: c.uid1CaseId,
          relationship: c.relationship,
          commonLoci: c.commonLoci,
          matchingAlleles: c.matchingLoci,
          mac: c.mac,
          parentChildLR: c.parentChildProb,
          fullSiblingLR: c.fullSiblingsProb,
          extendedFamilyLR: c.extFamilyProb,
          createdAt: Date.now(),
          relative1: {
            id: c.uid1Sample.id,
            profileId: c.uid1Sample.id,
            caseId: c.uid1Sample.cases[0]?.id,
            name: c.uid1Sample.name,
            kit: c.uid1Sample.kitId,
            gender: c.uid1Sample.sex,
            age: c.uid1Sample.ageYears,
            dobDay: c.uid1Sample.dateOfBirth ? new Date(c.uid1Sample.dateOfBirth).getDay() : undefined,
            dobMonth: c.uid1Sample.dateOfBirth ? new Date(c.uid1Sample.dateOfBirth).getMonth() : undefined,
            dobYear: c.uid1Sample.dateOfBirth ? new Date(c.uid1Sample.dateOfBirth).getFullYear() : undefined,
          },
          relative2: {
            id: c.uid2Sample.id,
            profileId: c.uid2Sample.id,
            caseId: c.uid2Sample.cases[0]?.id,
            name: c.uid2Sample.name,
            kit: c.uid2Sample.kitId,
            gender: c.uid2Sample.sex,
            age: c.uid2Sample.ageYears,
            dobDay: c.uid2Sample.dateOfBirth ? new Date(c.uid2Sample.dateOfBirth).getDay() : undefined,
            dobMonth: c.uid2Sample.dateOfBirth ? new Date(c.uid2Sample.dateOfBirth).getMonth() : undefined,
            dobYear: c.uid2Sample.dateOfBirth ? new Date(c.uid2Sample.dateOfBirth).getFullYear() : undefined,
          },
        }));
        console.log("Mapped kinship records:", resultsData);
        return resultsData;
      } catch (error) {
        console.error("Error mapping kinship records:", error);
        return [];
      }
    },
    enabled: !!caseId,
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<any> }) =>
      null,//api.updateProfile(id, data),
    onSuccess: (_, variables) => {
      // Get the caseId from the updated profile data or invalidate all profiles
      queryClient.invalidateQueries({ queryKey: ["profiles"] });
      queryClient.invalidateQueries({ queryKey: ["kinship"] });
    },
  });
}

export function useDeleteCase() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => null,//api.deleteCase(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cases"] });
      queryClient.invalidateQueries({ queryKey: ["profiles"] });
      queryClient.invalidateQueries({ queryKey: ["kinship"] });
    },
  });
}
